<template>
    <MainContainer />
</template>

<script>
// components
import { MainContainer } from '@/components/templates'

export default {
    components: {
        MainContainer,
    },
}
</script>
